import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import type { FC, ReactNode } from 'react';
import { EDR_COLORS, edrCardSx } from './edrTokens';

type EdrDataCardProps = {
  toolbar: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
};

export const EdrDataCard: FC<EdrDataCardProps> = ({
  toolbar,
  children,
  footer,
}) => (
  <Card sx={{ ...edrCardSx, overflow: 'hidden' }}>
    <CardContent style={{ padding: 0 }}>
      <Box style={{ padding: '12px 16px', borderBottom: `1px solid ${EDR_COLORS.borderSubtle}` }}>
        {toolbar}
      </Box>
      {children}
      {footer ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          style={{
            padding: '12px 16px',
            borderTop: `1px solid ${EDR_COLORS.borderSubtle}`,
          }}
        >
          {footer}
        </Box>
      ) : null}
    </CardContent>
  </Card>
);

type EdrTableFooterProps = {
  showing: string;
  onPrevious?: () => void;
  onNext?: () => void;
  hasPrevious?: boolean;
  hasNext?: boolean;
};

export const EdrTableFooter: FC<EdrTableFooterProps> = ({
  showing,
  onPrevious,
  onNext,
  hasPrevious = false,
  hasNext = true,
}) => (
  <>
    <Typography
      style={{
        fontSize: 10,
        fontWeight: 600,
        letterSpacing: '0.4px',
        textTransform: 'uppercase',
        color: EDR_COLORS.textMuted,
      }}
    >
      {showing}
    </Typography>
    <Box display="flex" style={{ gap: 8 }}>
      <Box
        component="button"
        type="button"
        onClick={onPrevious}
        disabled={!hasPrevious}
        style={{
          height: 28,
          padding: '0 12px',
          borderRadius: 6,
          border: `1px solid ${EDR_COLORS.borderStrong}`,
          background: EDR_COLORS.bgSurface,
          color: EDR_COLORS.textBody,
          fontSize: 11,
          fontWeight: 600,
          cursor: hasPrevious ? 'pointer' : 'default',
          opacity: hasPrevious ? 1 : 0.5,
        }}
      >
        Previous
      </Box>
      <Box
        component="button"
        type="button"
        onClick={onNext}
        disabled={!hasNext}
        style={{
          height: 28,
          padding: '0 12px',
          borderRadius: 6,
          border: `1px solid ${EDR_COLORS.slate700}`,
          background: EDR_COLORS.slate700,
          color: '#fff',
          fontSize: 11,
          fontWeight: 600,
          cursor: hasNext ? 'pointer' : 'default',
          opacity: hasNext ? 1 : 0.5,
        }}
      >
        Next
      </Box>
    </Box>
  </>
);
